import cx from 'clsx';
import React from 'react';
import { type Control, useController } from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';

import { ReactComponent as AttachmentsFieldIcon } from '@assets/svg/attachments-field.svg';

import FilePreview from '@components/common/FilePreview/FilePreview';

import { MODAL_NAMES } from '@constants/modalRenderers';

import useTranslation from '@hooks/useTranslation';

import type { IFile } from '@model/file';

import { useModalActions } from '@store/useModalStore';

import style from './style.module.scss';

interface IProps {
  name: string;
  control: Control<any>;
  label: string;
}

const AttachmentsField = ({ name, control, label }: IProps) => {
  const { t } = useTranslation();
  const { setSecondaryModal } = useModalActions();

  const {
    field: { value, onChange },
  } = useController({ name, control });

  const removeFile = (file: IFile) => {
    const filteredFilesList = value.filter((item: IFile) => item.url !== file.url);

    onChange(filteredFilesList);
  };

  const showUploadModal = () => {
    setSecondaryModal({ name: MODAL_NAMES.attachFilesModal, options: { name, control } });
  };

  return (
    <div className={style.attaches}>
      {label && <label className={style.attachmentsLabel}>{t(label)}</label>}
      {!!value.length && (
        <>
          <div className={cx(style.attachBtnRight)} onClick={showUploadModal}>
            <AttachmentsFieldIcon className={style.uploadIconRight} />
            <span className={cx(style.attachesLink, style.attachesLinkRight)}>{t('Click To Upload')} </span>
          </div>
          <div className={cx(style.attachesFiles, style.scrollingBlock, 'lightbox-block')}>
            {value.map((file: IFile) => (
              <FilePreview key={uuidv4()} file={file} removeFile={(file) => removeFile(file)} />
            ))}
          </div>
        </>
      )}
      {!value.length && (
        <div className={style.attachesBlock} onClick={showUploadModal}>
          <AttachmentsFieldIcon className={style.uploadIcon} />
          <span className={style.attachesLink}>{t('Click To Upload')} </span>
        </div>
      )}
    </div>
  );
};

export default AttachmentsField;
